import React from 'react';
import { Tooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import { ReactComponent as InfoSign } from '../../icons/InfoSign.svg';
import styles from './InfoTooltip.module.scss';

interface InfoTooltipProps {
  tooltipId: string;
  textKeys: readonly string[];
  className?: string;
  place?:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-start'
    | 'top-end'
    | 'bottom-start'
    | 'bottom-end'
    | 'left-start'
    | 'left-end'
    | 'right-start'
    | 'right-end';
  delayShow?: number;
  delayHide?: number;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  tooltipId,
  textKeys,
  className = '',
  place = 'top',
  delayShow = 200,
  delayHide = 200,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.infoTooltipWrapper}>
      <InfoSign
        className={`${styles.infoSignIcon} ${className}`}
        data-tooltip-id={tooltipId}
      />
      <Tooltip
        id={tooltipId}
        className={styles.tooltip}
        place={place}
        delayShow={delayShow}
        delayHide={delayHide}
        clickable={false}
        variant='light'
        opacity={1}
      >
        <div className={styles.tooltipContent}>
          <ul className={styles.tooltipList}>
            {textKeys.map((key, index) => (
              <li
                key={index}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(t(key) as string),
                }}
              />
            ))}
          </ul>
        </div>
      </Tooltip>
    </div>
  );
};

export default InfoTooltip;
